export default __webpack_public_path__ + "static/105-7d3cdb12ab012eb67016e61ac80a30ea.gif";